import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import moment from 'moment'
import styled from 'styled-components'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import { injectIntl, FormattedMessage } from 'react-intl'
import { isMobile, isTablet } from 'react-device-detect'
import { Upload, notification } from 'antd'

import useGetCar from 'core/hooks/useGetCar'
import * as routes from 'core/routing/constants/index'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import wizardsShape from 'core/components/wizard/shapes'

import {
  Modal,
  Spin,
  Skeleton,
  List,
  Checkbox,
  Row,
  Col,
  // Button,
  Carousel,
  Drawer
} from 'core/components/ui'
import SVG from 'core/components/svg'
import PageLoading from 'core/components/page-loading'
import TitleIcon from 'core/layouts/title-icon'
import Requester from 'core/requesters/Requester'

import { font, greys, borderRadius, fontFamily, lineHeight } from 'assets/themes/theme-default'
import svg from 'assets/svg'

import intialDefaultsViews from './VehicleAreas/initialDefaultView'
import VehicleAreas from './VehicleAreas'
import * as constants from './VehicleAreas/constants'
import CollapseAreas from './CollapseAreas'

import DamagePicturesModal from './DamagePicturesModal'
import UploadImageItem from './UploadImageItem'
import DamageList from './DamageList'

import { tradeInShape } from '../shapes'

const TableAreasWrapper = styled.div`
  margin-bottom: ${isMobile ? '20px' : '0px'};
`
const SubTitleWrapper = styled.div`
  background: ${greys.light3};
  font-size: ${font.size.base};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.italic.name},`}
    ${fontFamily.italic};
  line-height: ${isMobile && 'normal'};
  margin: ${isMobile ? '10px' : '0px auto 35px'};
  padding: ${isMobile ? '10px' : '15px'};
  border-radius: ${borderRadius.base};
  // text-align: center;
`
const TitleIconWrapper = styled.div`
  width: ${isMobile ? '20px' : '30px'};
  height: ${isMobile ? '20px' : '30px'};
  margin: 0 auto;
`
const Title = styled.h3`
  font-size: ${font.size.lg};
  color: ${greys.dark1};
  margin: 0 0 20px 0;
`
// const Picture = styled.span`
//   padding: 0 0.2rem;
// `
// const LinkButton = styled(Button)`
//   span {
//     text-decoration: underline;
//   }
// `
const StyledUpload = styled(Upload)`
  &&& .ant-upload-wrapper,
  &&& .ant-upload {
    width: 100%;
  }

  &&& .ant-upload.ant-upload-select {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  && .ant-upload-select-picture-card {
    width: 100%;
    height: 124px;
  }
`
const UploadPlaceholder = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 8px 6px;
  gap: 2px;
  line-height: 1.2;
`
const UploadPlaceholderTitle = styled.div`
  margin-top: 4px;
  font-size: ${font.size.base};
  color: ${greys.dark1};
`
const UploadPlaceholderMeta = styled.div`
  font-size: ${font.size.sm};
  color: ${greys.dark2};
  font-style: italic;
  line-height: 1.25;
`
const StyledCarousel = styled(Carousel)`
  && .slick-list .slick-track .slick-slide {
    width: 135px;
  }
  && .slick-dots li:not(.slick-active) button {
    background: #cecece;
  }
  && {
    height: 136px;
    -khtml-user-select: none;
    -o-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
  }
`
const TitleIcon2 = styled(SVG)`
  fill: ${props => props.theme.colors.color1.bg};
  vertical-align: middle;
`

const Icon = styled(SVG)`
  width: 20px;
  height: 20px;
  fill: ${greys.dark1};
  vertical-align: middle;
  cursor: pointer;
`

const ColDataInput = styled(Col)`
  padding-top: 2px;
`

const ColDataLabel = styled(Col)`
  color: ${greys.dark1};
  line-height: ${lineHeight.base};
`
const ClickableRow = styled(Row)`
  cursor: pointer;
  line-height: ${isMobile && 'normal'};
`

const Defaults = props => {
  const { setWizards, wizards, history, tradeIn, setTradeIn, intl } = props

  const [currentSection, setCurrentSection] = useState(null)

  const {
    loadingParamsDefaults,
    getParamsDefaults,
    paramsDefaults,
    getOthersDefaults,
    loadingOthersDefaults,
    othersDefaults,
    getSaddleryDefaults,
    loadingSaddleryDefaults,
    saddleryDefaults,
    getDefaults,
    loading,
    defaults
  } = useGetCar({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })

  const [pricingPolicy, setPricingPolicy] = useState(null)
  const [damagesSections, setDamagesSections] = useState([])
  const [sections, setSections] = useState(intialDefaultsViews)
  const [modalVisible, setModalVisible] = useState(false)
  const [defaultDatas, setDefaultDatas] = useState([])

  const [visibleDamagePicturesModal, setVisibleDamagePicturesModal] = useState(false)
  const [damagePictures, setDamagePictures] = useState([])
  const [damagePicturesModalTitle, setDamagePicturesModalTitle] = useState('')
  const [currentDefect, setCurrentDefect] = useState()

  const [pictures, setPictures] = useState([])
  const [previewPicture, setPreviewPicture] = useState()
  const [modalPreviewVisible, setModalPreviewVisible] = useState(false)

  const { vehicle } = tradeIn
  const { damages } = vehicle

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]
    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.TRADEIN_DEFAULTS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsTradeIn: extendedSteps }
    setWizards(extentedWizards)
  }

  const handleModalVisible = () => {
    setModalVisible(!modalVisible)
  }

  const getAge = () => {
    if (tradeIn.vehicle.wsDatas === null) return null
    return moment()
      .diff(moment(tradeIn.vehicle.wsDatas.putIntoService), 'months', true)
      .toFixed(2)
  }

  const getMileage = () => {
    if (tradeIn.vehicle.mileage === null) return null
    return tradeIn.vehicle.mileage
  }

  const loadOthersDefaults = pricingPolicyWs => {
    const params = {
      pricingPolicyId: pricingPolicyWs.id,
      estimatedDamageId: pricingPolicyWs.estimatedDamageId,
      section: constants.SECTIONS.OTHER,
      age: getAge(),
      mileage: getMileage()
    }
    getOthersDefaults(params)
  }

  const loadSaddleryDefaults = pricingPolicyWs => {
    const params = {
      pricingPolicyId: pricingPolicyWs.id,
      estimatedDamageId: pricingPolicyWs.estimatedDamageId,
      section: constants.SECTIONS.SADDLERY,
      age: getAge(),
      mileage: getMileage()
    }
    getSaddleryDefaults(params)
  }

  const onSelect = section => {
    setCurrentSection(section)
    const params = {
      pricingPolicyId: pricingPolicy.id,
      estimatedDamageId: pricingPolicy.estimatedDamageId,
      section,
      age: getAge(),
      mileage: getMileage()
    }
    getDefaults(params)

    handleModalVisible()
  }

  const isDefaultsEmpty = () => {
    const datas = sections.filter(el => el.damages && el.damages.length > 0)
    if (datas.length > 0) {
      return false
    }
    return true
  }
  const onDeleteDefect = defect => {
    const filteredDamages = damages.filter(el => el.id !== defect.id)

    const extendedVehicle = { ...vehicle, damages: filteredDamages }
    setTradeIn({
      ...tradeIn,
      vehicle: extendedVehicle
    })
  }
  const onChangeSectionDefects = (defect, sectionTo) => {
    const damageSection = damagesSections.find(
      section => Number(section.key) === Number(sectionTo || currentSection)
    )
    const isSelected = !damages ? false : damages.filter(el => el.id === defect.id).length > 0

    let extendedDamages = damages ? [...damages] : []

    if (!isSelected) {
      extendedDamages.push({
        ...defect,
        sectionId: sectionTo || currentSection,
        section: damageSection.value
      })
    } else {
      extendedDamages = damages.filter(el => el.id !== defect.id)
    }

    const extendedVehicle = { ...vehicle, damages: extendedDamages }
    setTradeIn({
      ...tradeIn,
      vehicle: extendedVehicle
    })
  }

  useEffect(() => {
    const newDefaultsViews = intialDefaultsViews.map(item => {
      const { zones } = item

      let damagesToApply = []
      zones.forEach(zone => {
        const filteredDamages = damages
          ? damages.filter(damage => damage.sectionId === zone.id)
          : []

        const finalDamages = filteredDamages.map(damage => {
          const damageSection = damagesSections.find(section => Number(section.key) === zone.id)

          return { ...damage, sectionWording: damageSection && damageSection.value }
        })

        if (filteredDamages.length > 0) damagesToApply = _.concat(damagesToApply, finalDamages)
      })

      return {
        ...item,
        zones: zones.map(zone => {
          const damageSection = damagesSections.find(section => Number(section.key) === zone.id)

          const filteredDamages = damages
            ? damages.filter(damage => damage.sectionId === zone.id)
            : []

          return {
            ...zone,
            label: damageSection && damageSection.value,
            decorator: { ...zone.decorator, value: filteredDamages.length }
          }
        }),
        damages: damagesToApply
      }
    })

    setSections(newDefaultsViews)
  }, [damagesSections, damages])

  useEffect(() => {
    const runIt = datas => {
      const { pricingPolicyWs, sectionsWs, vatsWs } = datas
      const extendedVehicle = { ...vehicle, pricingPolicy: pricingPolicyWs, tax: vatsWs.rate }
      setTradeIn({
        ...tradeIn,
        vehicle: extendedVehicle
      })

      setPricingPolicy(pricingPolicyWs)
      setDamagesSections(sectionsWs)
      loadOthersDefaults(pricingPolicyWs)
      loadSaddleryDefaults(pricingPolicyWs)
    }

    if (paramsDefaults && paramsDefaults.pricingPolicyWs && paramsDefaults.sectionsWs)
      runIt(paramsDefaults)
  }, [paramsDefaults])

  useEffect(() => {
    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(step => step.hash === routes.TRADEIN_DEFAULTS)
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }
    getParamsDefaults()

    activateNextStep()
  }, [])

  useEffect(() => {
    if (vehicle.pictures && vehicle.pictures.length && !pictures.length) {
      setPictures(
        vehicle.pictures.map(x => ({
          ...x,
          url: x.pictureUrl,
          thumbUrl: `${x.pictureUrl}&width=200&height=200`,
          previewUrl: `${x.pictureUrl}&width=600&height=600`,
          uid: x.name,
          status: 'done'
        }))
      )
    }
  }, [vehicle.pictures])

  const handleShowDamagePicturesModal = async defect => {
    if (defect && defect.defectWording) {
      if (defect.sectionId) {
        await setCurrentSection(defect.sectionId)
      }

      const selectedDefect = damages.find(
        x => x.sectionId === (defect.sectionId || currentSection) && x.defectId === defect.defectId
      )

      if (selectedDefect) {
        setDamagePictures(
          selectedDefect.pictures
            ? selectedDefect.pictures.map(x => ({
                ...x,
                url: x.pictureUrl,
                thumbUrl: `${x.pictureUrl}&width=200&height=200`,
                previewUrl: `${x.pictureUrl}&width=600&height=600`,
                uid: x.name,
                status: 'done'
              }))
            : []
        )
        setDamagePicturesModalTitle(
          intl.formatMessage(
            { id: 'tradeIn-defaults-pictures-modal-visuals-defect' },
            { value: defect.defectWording }
          )
        )
        setCurrentDefect(selectedDefect)
      }
    } else {
      setDamagePictures([])
      setDamagePicturesModalTitle()
      setCurrentDefect()
    }
    setVisibleDamagePicturesModal(!visibleDamagePicturesModal)
  }

  const acceptedExtensions = ['.jpg', '.jpeg', '.png', '.tif', '.tiff', '.gif', '.svg', '.bmp']

  const isFileAccepted = file => {
    if (
      (file.fileExtension && acceptedExtensions.includes(`.${file.fileExtension}`)) ||
      acceptedExtensions.includes(`.${file.name.split('.').pop()}`.toLowerCase())
    ) {
      return true
    }
    return false
  }

  const handleDamagesFileListChange = e => {
    const { file, fileList } = e
    if (file.status === 'done') {
      const { temporaryFile } = file.response

      const defect = damages.find(
        x => x.sectionId === currentSection && x.defectId === currentDefect.defectId
      )
      defect.pictures = defect.pictures
        ? [...defect.pictures, { ...temporaryFile, pictureUrl: temporaryFile.fileUrl }]
        : [{ ...temporaryFile, pictureUrl: temporaryFile.fileUrl }]

      const extendedVehicle = {
        ...vehicle,
        damages: [
          ...damages.filter(
            x =>
              x.sectionId !== currentSection ||
              (x.sectionId === currentSection && x.defectId !== defect.defectId)
          ),
          defect
        ]
      }
      setTradeIn({
        ...tradeIn,
        vehicle: extendedVehicle
      })
      setDamagePictures([
        ...fileList.filter(x => x.uid !== file.uid),
        {
          ...file,
          uid: temporaryFile.name,
          url: temporaryFile.fileUrl
        }
      ])
    } else {
      if (file.status === 'error' && file.response && file.response.message) {
        notification.error({
          message: intl.formatMessage({ id: 'error' }),
          description: file.response.message
        })
      }
      setDamagePictures([...fileList.filter(x => isFileAccepted(x))])
    }
  }

  const handleRemoveFile = file => {
    const defect = damages.find(
      x => x.sectionId === currentSection && x.defectId === currentDefect.defectId
    )
    if (defect.pictures && defect.pictures.find(x => x.name === file.uid)) {
      defect.pictures = defect.pictures.filter(x => x.name !== file.uid)
      const extendedVehicle = {
        ...vehicle,
        damages: [
          ...damages.filter(
            x =>
              x.sectionId !== currentSection ||
              (x.sectionId === currentSection && x.defectId !== defect.defectId)
          ),
          defect
        ]
      }
      setTradeIn({
        ...tradeIn,
        vehicle: extendedVehicle
      })
    } else {
      setDamagePictures(damagePictures.filter(x => x.uid !== file.uid))
    }
  }

  const getDefectById = id => damages.find(x => x.id === id)

  const handleFileListChange = e => {
    const { file, fileList } = e
    if (file.status === 'done') {
      const { temporaryFile } = file.response
      const extendedVehicle = {
        ...vehicle,
        pictures: vehicle.pictures
          ? [...vehicle.pictures, { ...temporaryFile, pictureUrl: temporaryFile.fileUrl }]
          : [{ ...temporaryFile, pictureUrl: temporaryFile.fileUrl }]
      }
      setTradeIn({
        ...tradeIn,
        vehicle: extendedVehicle
      })
      setPictures([
        ...fileList.filter(x => x.uid !== file.uid),
        {
          ...file,
          uid: temporaryFile.name,
          url: temporaryFile.fileUrl
        }
      ])
    } else {
      if (file.status === 'error' && file.response && file.response.message) {
        notification.error({
          message: intl.formatMessage({ id: 'error' }),
          description: file.response.message
        })
      }
      setPictures([...fileList.filter(x => isFileAccepted(x))])
    }
  }

  const handleRemovePicture = file => {
    setPictures([...pictures.filter(x => x.uid !== file.uid)])
    if (vehicle.pictures && vehicle.pictures.length) {
      const extendedVehicle = {
        ...vehicle,
        pictures:
          vehicle.pictures && vehicle.pictures.length
            ? vehicle.pictures.filter(x => x.name !== file.uid)
            : []
      }
      setTradeIn({
        ...tradeIn,
        vehicle: extendedVehicle
      })
    }
  }

  const getBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })

  const handlePreview = async picture => {
    if (!picture.previewUrl) {
      picture.previewUrl = await getBase64(picture.originFileObj) // eslint-disable-line
    }
    setPreviewPicture(picture.previewUrl)
    setModalPreviewVisible(true)
  }
  const handleCancelPreview = () => {
    setModalPreviewVisible(false)
  }

  const handleDownload = file => {
    const a = document.createElement('a')
    a.href = file.url
    a.target = '_blank'
    a.download = file.url.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
  useEffect(() => {
    setDefaultDatas(sections.filter(el => el.damages && el.damages.length > 0))
  }, [sections])

  const renderImgUpload = () => (
    <>
      <Title>
        {intl.formatMessage({
          id: 'tradeIn-defaults-title-pictures-upload'
        })}
      </Title>
      <Row type="flex" justify="start" gutter={18}>
        <Col lg={8} sm={8} xs={24}>
          <StyledUpload
            headers={{
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('bearer')).jwt}`
            }}
            action={`${Requester.API.urlFileRender}/files/temporary`}
            onChange={handleFileListChange}
            method="POST"
            fileList={pictures}
            defaultFileList={pictures}
            showUploadList={false}
            listType="picture-card"
            multiple
            accept="image/*"
            beforeUpload={file => isFileAccepted(file)}
            maxCount={20}
            disabled={pictures && pictures.length === 20}
          >
            <UploadPlaceholder>
              <Icon svg={svg.plus} />
              <UploadPlaceholderTitle>
                {intl.formatMessage({ id: 'tradeIn-defaults-pictures-modal-upload-button' })}
              </UploadPlaceholderTitle>
              <UploadPlaceholderMeta>
                {intl.formatMessage({ id: 'upload.max_size' }, { value: 20 })}
              </UploadPlaceholderMeta>
              <UploadPlaceholderMeta>
                {intl.formatMessage({ id: 'tradeIn-defaults-pictures-modal-max-count' })}
              </UploadPlaceholderMeta>
            </UploadPlaceholder>
          </StyledUpload>
        </Col>
        <Col lg={16} sm={16} xs={24}>
          {pictures && pictures.length > 0 && (
            <StyledCarousel swipeToSlide variableWidth infinite={false} draggable slidesToShow={2}>
              {pictures.map(file => (
                <UploadImageItem
                  file={file}
                  editable
                  onRemove={handleRemovePicture}
                  onPreview={handlePreview}
                  onDownload={handleDownload}
                />
              ))}
            </StyledCarousel>
          )}
        </Col>
      </Row>
    </>
  )

  return (
    <MainContentWrapper>
      <TitleIcon
        cssId="globaldealer-title-8"
        title={intl.formatMessage({
          id: 'tradeIn-defaults-subtitle-1'
        })}
      />
      {loadingParamsDefaults ? (
        <PageLoading />
      ) : (
        <>
          <Row type="flex" justify="center">
            <Col lg={20} xs={24}>
              <SubTitleWrapper>
                <Row type="flex" justify="center" gutter={13}>
                  <Col lg={3} xs={3}>
                    <TitleIconWrapper>
                      <TitleIcon2 svg={svg.lightBulb} />
                    </TitleIconWrapper>
                  </Col>
                  <Col lg={21} xs={21}>
                    <FormattedMessage id="tradeIn-defaults-information-1" />
                    <br />
                    <FormattedMessage id="tradeIn-defaults-information-2" />
                  </Col>
                </Row>
              </SubTitleWrapper>
            </Col>
          </Row>
          <Row type="flex">
            <Col span={isMobile && !isTablet ? 24 : 12}>
              <VehicleAreas sections={sections} onSelect={onSelect} />
            </Col>
            <Col span={isMobile && !isTablet ? 24 : 10} offset={!isMobile || isTablet ? 2 : 0}>
              {othersDefaults.totalDefects > 0 && (
                <>
                  <Title>{othersDefaults.sectionValue}</Title>
                  {loadingOthersDefaults ? (
                    <div style={{ textAlign: 'center', marginTop: '30px' }}>
                      <Spin />
                    </div>
                  ) : (
                    <List
                      style={{ marginBottom: '20px' }}
                      rows={0}
                      dataSource={othersDefaults.defects}
                      renderItem={item => {
                        const { defectWording } = item
                        const isSelected = !damages
                          ? false
                          : damages.filter(el => el.id === item.id).length > 0
                        return (
                          <List.Item>
                            <ClickableRow
                              type="flex"
                              style={{ width: '100%' }}
                              align="top"
                              gutter={35}
                              onClick={() => onChangeSectionDefects(item, constants.SECTIONS.OTHER)}
                            >
                              <ColDataInput span={isMobile ? 3 : 2}>
                                <Checkbox checked={isSelected} />
                              </ColDataInput>
                              <ColDataLabel span={isMobile ? 21 : 22}>{defectWording}</ColDataLabel>
                            </ClickableRow>
                          </List.Item>
                        )
                      }}
                    />
                  )}
                </>
              )}
              {saddleryDefaults.totalDefects > 0 && (
                <>
                  <Title>{saddleryDefaults.sectionValue}</Title>
                  {loadingSaddleryDefaults ? (
                    <div style={{ textAlign: 'center', marginTop: '30px' }}>
                      <Spin />
                    </div>
                  ) : (
                    <List
                      rows={0}
                      dataSource={saddleryDefaults.defects}
                      renderItem={item => {
                        const { defectWording } = item
                        const isSelected = !damages
                          ? false
                          : damages.filter(el => el.id === item.id).length > 0
                        return (
                          <List.Item>
                            <ClickableRow
                              type="flex"
                              style={{ width: '100%' }}
                              align="top"
                              gutter={35}
                              onClick={() =>
                                onChangeSectionDefects(item, constants.SECTIONS.SADDLERY)
                              }
                            >
                              <ColDataInput span={isMobile ? 3 : 2}>
                                <Checkbox
                                  checked={isSelected}
                                  onClick={() =>
                                    onChangeSectionDefects(item, constants.SECTIONS.SADDLERY)
                                  }
                                />
                              </ColDataInput>
                              <ColDataLabel span={isMobile ? 21 : 22}>{defectWording}</ColDataLabel>
                            </ClickableRow>
                          </List.Item>
                        )
                      }}
                    />
                  )}
                </>
              )}
              {saddleryDefaults.totalDefects === 0 &&
                othersDefaults.totalDefects === 0 &&
                renderImgUpload()}
            </Col>
          </Row>
          <Row type="flex" gutter={24}>
            {!isDefaultsEmpty() && (
              <>
                <Col lg={{ span: 12 }} xs={{ span: 24, pull: 0 }}>
                  <Title>
                    {intl.formatMessage({
                      id: 'tradeIn-defaults-title-table-areas'
                    })}
                  </Title>
                  <TableAreasWrapper>
                    <CollapseAreas
                      sections={defaultDatas}
                      onDeleteDefect={onDeleteDefect}
                      onShowDamagePicturesModal={handleShowDamagePicturesModal}
                    />
                  </TableAreasWrapper>
                </Col>
                {!isMobile && <Col lg={{ span: 2 }} />}
              </>
            )}

            <Col lg={{ span: 10 }} xs={{ span: 24, offset: 0 }}>
              {(saddleryDefaults.totalDefects && saddleryDefaults.totalDefects > 0) ||
              (othersDefaults.totalDefects && othersDefaults.totalDefects > 0)
                ? renderImgUpload()
                : null}
              {!isMobile && (
                <Modal visible={modalPreviewVisible} footer={null} onCancel={handleCancelPreview}>
                  <img alt="Preview" style={{ width: '100%' }} src={previewPicture} />
                </Modal>
              )}
            </Col>
          </Row>
        </>
      )}
      {!isMobile ? (
        <>
          <Modal
            visible={modalVisible && !visibleDamagePicturesModal}
            onCancel={handleModalVisible}
            footer={null}
            title={loading ? <Skeleton paragraph={{ rows: 0 }} loading /> : defaults.sectionValue}
          >
            <DamageList
              loading={loading}
              getDefectById={getDefectById}
              handleShowDamagePicturesModal={handleShowDamagePicturesModal}
              onChangeSectionDefects={onChangeSectionDefects}
              defaults={defaults}
              damages={damages}
            />
          </Modal>
        </>
      ) : (
        <>
          <Drawer
            visible={modalVisible}
            onClose={handleModalVisible}
            footer={null}
            placement="bottom"
            height="326"
            title={loading ? <Skeleton paragraph={{ rows: 0 }} loading /> : defaults.sectionValue}
          >
            <DamageList
              loading={loading}
              getDefectById={getDefectById}
              handleShowDamagePicturesModal={handleShowDamagePicturesModal}
              onChangeSectionDefects={onChangeSectionDefects}
              defaults={defaults}
              damages={damages}
            />
          </Drawer>
          <Drawer
            placement="bottom"
            height="326"
            width="700px"
            visible={modalPreviewVisible}
            onClose={handleCancelPreview}
          >
            <img alt="Preview" style={{ width: '100%' }} src={previewPicture} />
          </Drawer>
        </>
      )}
      <DamagePicturesModal
        title={damagePicturesModalTitle}
        visible={visibleDamagePicturesModal}
        pictures={damagePictures}
        onClose={handleShowDamagePicturesModal}
        onRemove={handleRemoveFile}
        onChange={handleDamagesFileListChange}
        isFileAccepted={isFileAccepted}
      />
    </MainContentWrapper>
  )
}

Defaults.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  intl: PropTypes.shape().isRequired,
  tradeIn: tradeInShape.isRequired,
  setTradeIn: PropTypes.func.isRequired
}

export default withRouter(injectIntl(Defaults))
